import React, { useRef, useEffect } from 'react';
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import StopRoundedIcon from '@mui/icons-material/StopRounded';
import constants from '../../../constants/constants';
import './ChatComposer.css';

const MAX_TEXTAREA_HEIGHT_PX = 110;

const ChatComposer = ({ value, onChange, onSend, onStop, isStreaming, disabled }) => {
    const textareaRef = useRef(null);

    // Grow with the content, up to a cap, then scroll inside.
    useEffect(() => {
        const element = textareaRef.current;
        if (!element) return;
        element.style.height = 'auto';
        element.style.height = `${Math.min(element.scrollHeight, MAX_TEXTAREA_HEIGHT_PX)}px`;
    }, [value]);

    const canSend = value.trim().length > 0 && !isStreaming && !disabled;

    const handleKeyDown = (event) => {
        // Enter sends, Shift+Enter makes a new line.
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            if (canSend) onSend();
        }
    };

    return (
        <div className='chat-composer'>
            <textarea
                ref={textareaRef}
                className='chat-composer__input'
                value={value}
                onChange={(e) => onChange(e.target.value)}
                onKeyDown={handleKeyDown}
                placeholder={constants.CHAT.PLACEHOLDER}
                rows={1}
                dir='rtl'
                maxLength={1000}
                disabled={disabled}
            />

            {isStreaming ? (
                <button type='button' className='chat-composer__button chat-composer__button--stop' onClick={onStop} aria-label={constants.CHAT.STOP}>
                    <StopRoundedIcon />
                </button>
            ) : (
                <button
                    type='button'
                    className='chat-composer__button'
                    onClick={onSend}
                    disabled={!canSend}
                    aria-label={constants.CHAT.SEND}
                >
                    <SendRoundedIcon />
                </button>
            )}
        </div>
    );
};

export default ChatComposer;
